import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Configuration } from '../../constants/config';

/*
  Generated class for the SettingsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SettingsServiceProvider {

    private ServerWithApiUrl: string;

    constructor(public http: Http, _configuration: Configuration) {
        this.ServerWithApiUrl = _configuration.ServerWithApiUrl;
    }

    /**
     * @Info Get Parameter
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-24
     */
    read(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Settings/readSetting', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }


    /**
     * @Info Set Parameters
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    update(data) {
        return new Promise(resolve => {
            this.http.post(this.ServerWithApiUrl+'Settings/updateSetting', data)
                .map(res => res.json())
                .subscribe(data => {
                    resolve(data);
                }, error=>{
                    resolve({Success: false, Message: "", Error: true, ErrorMessage: "An error has occurred"});
                });


        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/settings-service/settings-service.ts